export const INSPECTION_TYPES = {
  NETWORK_BY_SECTION: 'Сеть по секциям',
  NETWORK: 'Сеть по всему дому',
  SUBNET_BY_SECTION: 'Подсеть по секциям',
  SUBNET: 'Подсеть по всему дому',
};
